/**
 * Better Auth, client side.
 *
 * No `baseURL`: Fastify serves this bundle and `/api/auth/*` from the same
 * origin, so the session cookie needs no CORS configuration and no token
 * storage. In dev, Vite proxies both to the API process, which keeps the thing
 * being developed identical to the thing being shipped.
 *
 * Session *reading* deliberately does NOT go through this client. The server's
 * own `GET /api/me` returns the role from the `users` enum, which is the value
 * every guard in this app checks; going through one query key for it means the
 * bridge, the router and the socket gate all read the same cache entry.
 */

import { createAuthClient } from 'better-auth/react';

export const authClient = createAuthClient();

export async function signInWithPassword(
  email: string,
  password: string,
): Promise<{ ok: true } | { ok: false; message: string }> {
  const result = await authClient.signIn.email({ email, password });
  if (result.error) {
    return {
      ok: false,
      // Better Auth returns a machine code plus a message; the message is
      // deliberately vague about which half was wrong, which is correct.
      message: result.error.message ?? 'Sign-in failed',
    };
  }
  return { ok: true };
}

export async function signOut(): Promise<void> {
  await authClient.signOut();
}
